var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-center":""}},[_c('img',{attrs:{"src":require('../assets/club-thrive-logo.png'),"alt":"thrive","width":_vm.width}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }